// ! AUTO-GENERATED FILE
// ! DO NOT TOUCH !!!

// #pause-sonar#
import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { createPartsAgreement, CreatePartsAgreement$Params } from '../fn/parts-agreement/create-parts-agreement';
import {
  findPartsAgreementById,
  FindPartsAgreementById$Params,
} from '../fn/parts-agreement/find-parts-agreement-by-id';
import {
  retrievePartsAgreements,
  RetrievePartsAgreements$Params,
} from '../fn/parts-agreement/retrieve-parts-agreements';
import { updatePartsAgreement, UpdatePartsAgreement$Params } from '../fn/parts-agreement/update-parts-agreement';
import { PartsAgreementRestResponse } from '../models/parts-agreement-rest-response';
import { StrictHttpResponse } from '../strict-http-response';

@Injectable({ providedIn: 'root' })
export class PartsAgreementService extends BaseService {
  /** Path part for operation `findPartsAgreementById()` */
  static readonly FindPartsAgreementByIdPath = '/parts-agreement/{id}';

  /**
   * Get parts agreement by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findPartsAgreementById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPartsAgreementById$Response(
    params: FindPartsAgreementById$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PartsAgreementRestResponse>> {
    return findPartsAgreementById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get parts agreement by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findPartsAgreementById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPartsAgreementById(
    params: FindPartsAgreementById$Params,
    context?: HttpContext,
  ): Observable<PartsAgreementRestResponse> {
    return this.findPartsAgreementById$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartsAgreementRestResponse>): PartsAgreementRestResponse => r.body),
    );
  }

  /** Path part for operation `updatePartsAgreement()` */
  static readonly UpdatePartsAgreementPath = '/parts-agreement/{id}';

  /**
   * Update existing parts agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePartsAgreement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartsAgreement$Response(
    params: UpdatePartsAgreement$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PartsAgreementRestResponse>> {
    return updatePartsAgreement(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing parts agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePartsAgreement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartsAgreement(
    params: UpdatePartsAgreement$Params,
    context?: HttpContext,
  ): Observable<PartsAgreementRestResponse> {
    return this.updatePartsAgreement$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartsAgreementRestResponse>): PartsAgreementRestResponse => r.body),
    );
  }

  /** Path part for operation `retrievePartsAgreements()` */
  static readonly RetrievePartsAgreementsPath = '/parts-agreement';

  /**
   * Get all parts agreements.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retrievePartsAgreements()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrievePartsAgreements$Response(
    params?: RetrievePartsAgreements$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<PartsAgreementRestResponse>>> {
    return retrievePartsAgreements(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all parts agreements.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `retrievePartsAgreements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrievePartsAgreements(
    params?: RetrievePartsAgreements$Params,
    context?: HttpContext,
  ): Observable<Array<PartsAgreementRestResponse>> {
    return this.retrievePartsAgreements$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PartsAgreementRestResponse>>): Array<PartsAgreementRestResponse> => r.body),
    );
  }

  /** Path part for operation `createPartsAgreement()` */
  static readonly CreatePartsAgreementPath = '/parts-agreement';

  /**
   * Create new parts agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPartsAgreement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartsAgreement$Response(
    params: CreatePartsAgreement$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PartsAgreementRestResponse>> {
    return createPartsAgreement(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new parts agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPartsAgreement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartsAgreement(
    params: CreatePartsAgreement$Params,
    context?: HttpContext,
  ): Observable<PartsAgreementRestResponse> {
    return this.createPartsAgreement$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartsAgreementRestResponse>): PartsAgreementRestResponse => r.body),
    );
  }
}

// #continue-sonar#
